const BRANDS = {
  mop: {
    key: "mop",
    name: "My Orthopedic Problem",
    shortName: "MOP",
    domain: "myorthopedicproblem.com",
    appDomain: "app.myorthopedicproblem.com",
    speciality: "Musculoskeletal",
    tagline:
      "Your trusted guide for joint pain, injuries, and orthopedic care –\nfrom first symptoms to recovery.",
    checkerName: "OrthoCheck",
    checkerPath: "/orthocheck",
    healthInsightsPath: "musculoskeletal",
    webUrl: "https://myorthopedicproblem.com",
    educationPath: "/category/knee",
    social: {
      facebook: "https://www.facebook.com/myorthoproblem",
      instagram: "https://www.instagram.com/myorthopedicproblem",
      twitter: "https://twitter.com/myorthoproblem",
      linkedin: "https://www.linkedin.com/company/my-orthopedic-problem",
      youtube: "https://www.youtube.com/@Myorthopedicproblem",
    },
  },
  mdp: {
    key: "mdp",
    name: "My Dental Problem",
    shortName: "MDP",
    domain: "mydentalproblem.com",
    appDomain: "app.mydentalproblem.com",
    speciality: "Dental",
    tagline:
      "Your trusted guide for dental pain, oral health, and dental care –\nfrom first symptoms to recovery.",
    checkerName: "DentalCheck",
    checkerPath: "/dentalcheck",
    healthInsightsPath: "dental",
    webUrl: "https://mydentalproblem.com",
    educationPath: "/category/teeth",
    social: {
      facebook: "https://www.facebook.com/mydentalproblem",
      instagram: "https://www.instagram.com/mydentalproblem",
      twitter: "https://twitter.com/mydentalproblem",
      linkedin: "https://www.linkedin.com/company/my-dental-problem",
      youtube: "https://www.youtube.com/@Mydentalproblem",
    },
  },
};

/**
 * Detect the current brand from hostname or env var override.
 * - REACT_APP_BRAND env var takes priority (for local dev)
 * - *.mydentalproblem.com hostnames → MDP
 * - Everything else → MOP (default)
 */
export function getBrand() {
  const envBrand = process.env.REACT_APP_BRAND;
  if (envBrand && BRANDS[envBrand.toLowerCase()]) {
    return BRANDS[envBrand.toLowerCase()];
  }

  const hostname = window.location.hostname;
  if (hostname.endsWith("mydentalproblem.com")) {
    return BRANDS.mdp;
  }

  return BRANDS.mop;
}

/** Current brand config (evaluated once at module load) */
export const brand = getBrand();

export default BRANDS;
